export default __webpack_public_path__ + "static/media/about.bf938873.jpeg";